// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner[data-v-a6fab67a]{margin-top:80px}@media screen and (max-width:959px){.banner[data-v-a6fab67a]{margin-top:40px}}.the-footer--no-banner[data-v-a6fab67a]{margin-top:80px}@media screen and (max-width:959px){.the-footer--no-banner[data-v-a6fab67a]{margin-top:40px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
